import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import { getBlogPosts } from "../api/apiCalls";
import { getBlogImage, getBlogImageAlt } from "../utils/blogImages";
import { createBlogIndexSchema, usePageSeo } from "../utils/seo";

function BlogIndex() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    getBlogPosts().then((apiPosts) => {
      if (isMounted) {
        setPosts(apiPosts);
        setIsLoading(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  usePageSeo({
    title: "Buzz Mobile блог - совети за телефони, сервис и додатоци",
    description:
      "Практични совети од Buzz Mobile за купување телефон, сервис, батерии, полначи, слушалки и мобилна галантерија во Македонија.",
    canonicalPath: "/blog",
    structuredData: createBlogIndexSchema(posts),
  });

  const hasPosts = posts.length > 0;

  return (
    <main className="blog-page">
      <section className="blog-hero">
        <div className="container blog-hero__inner">
          <div className="blog-hero__copy">
            <span className="blog-eyebrow">Buzz Mobile блог</span>
            <h1>Совети за паметна куповина, сервис и мобилни додатоци.</h1>
            <p>
              Водичи напишани за луѓе што сакаат да купат подобар телефон,
              да избегнат скапи сервисни грешки и да изберат додатоци што
              навистина одговараат на нивниот уред.
            </p>
          </div>
          <div className="blog-hero__signal" aria-label="SEO фокус">
            <QueryStatsIcon />
            <strong>Локални, корисни и редовно ажурирани содржини</strong>
            <span>Купување телефони, сервис и галантерија во Македонија</span>
          </div>
        </div>
      </section>

      <section className="container blog-index">
        {!hasPosts ? (
          <div className="blog-empty-state">
            {isLoading
              ? "Се вчитуваат блог постови..."
              : "Моментално нема објавени блог постови."}
          </div>
        ) : (
          <div className="blog-grid">
            {posts.map((post) => (
              <Link
                className="blog-card"
                key={post.slug}
                to={`/blog/${post.slug}`}
              >
                <div className="blog-card__image">
                  <img
                    className={!post.heroImage ? "blog-image--fallback" : undefined}
                    src={getBlogImage(post)}
                    alt={getBlogImageAlt(post)}
                  />
                </div>
                <div className="blog-card__body">
                  <span className="blog-chip">{post.category}</span>
                  <h2>{post.title}</h2>
                  <p>{post.excerpt}</p>
                  <div className="blog-card__meta">
                    <span>
                      <AccessTimeIcon fontSize="small" />
                      {post.readingTime}
                    </span>
                    <span>
                      <LocalOfferIcon fontSize="small" />
                      {post.focusTerm}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}

export default BlogIndex;
